import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Chip, Tooltip, useTheme, useMediaQuery, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useChat } from '../../context/chatContext'; // Import the context hook
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onMenuClick: () => void;
  pitchShown: boolean;
  // The onSettingsClick is now managed globally in App.tsx, so it can be removed from here
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, pitchShown }: any) => {
  // Consume the usageInfo from thSWSe ChatContext
  const { usageInfo, setActiveChatId} = useChat();
  const navigate = useNavigate();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme: any) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
             <MenuIcon />
        </IconButton>
        {/* Left: logo and title */}
        <Stack onClick={() => { setActiveChatId(null); navigate('/')}} sx={isMobile
  ? {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pointerEvents: "auto",
    }
  : {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      cursor: "pointer",
       position: "relative",
      left: "65px",
    }}>
          <Box
            component="img"
            src="/logo.png"
            alt="Logo"
            sx={{ height: 32, width: 32, mr: 2, position: 'relative', left: '5px', top: isMobile ? '8px' : '5px' }}
          />
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, overflow: 'visible' }}>
            Enantio
          </Typography>
        </Stack>
     

        {/* Middle: pitch navigation if needed */}
        {pitchShown && (
          <nav
            style={{ marginLeft: 32, marginRight: 96 }}
            className="hidden md:flex space-x-8 text-slate-300 font-medium"
          >
            <a href="#problem" className="nav-link">The Problem</a>
            <a href="#solution" className="nav-link">The Solution</a>
            <a href="#how" className="nav-link">How It Works</a>
            <a href="#vision" className="nav-link">Vision</a>
            <a href="#contact" className="nav-link">Contact</a>
          </nav>
        )}

        {/* Right: usage info */}
        {usageInfo && !isMobile && (
          <Box sx={{position: 'relative', right: 90}}>
            <Tooltip title={`${usageInfo.limit - usageInfo.usage} / ${usageInfo.limit} thoughts\n remaining this week`}>
            <Chip
              label={`${usageInfo.tier}: ${usageInfo.limit - usageInfo.usage} / ${usageInfo.limit}`}
              color="secondary"
              variant="outlined"
              sx={{ ml: 2 }}
            />
          </Tooltip>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;